import React, { useEffect } from "react";

interface PaymentPopupProps {
  sessionId: string;
  onPaymentSuccess?: (data: any) => void;
  onPaymentError?: (data: any) => void;
  onPaymentCancel?: (data: any) => void;
  onModalClose?: (data: any) => void;
}

declare global {
  interface Window {
    Reepay: any;
  }
}

const Reepay = window.Reepay;

const PaymentPopup: React.FC<PaymentPopupProps> = ({
  sessionId,
  onPaymentSuccess,
  onPaymentError,
  onPaymentCancel,
  onModalClose,
}) => {
  useEffect(() => {
    const rp = new Reepay.ModalSubscription(sessionId);

    rp.addEventHandler(Reepay.Event.Accept, function (data: any) {
      onPaymentSuccess && onPaymentSuccess(data);
    });

    rp.addEventHandler(Reepay.Event.Error, function (data: any) {
      onPaymentError && onPaymentError(data);
    });

    rp.addEventHandler(Reepay.Event.Cancel, function (data: any) {
      onPaymentCancel && onPaymentCancel(data);
    });

    rp.addEventHandler(Reepay.Event.Close, function (data: any) {
      onModalClose && onModalClose(data);
    });

    return () => {
      rp.removeEventHandler(Reepay.Event.Accept);
      rp.removeEventHandler(Reepay.Event.Error);
      rp.removeEventHandler(Reepay.Event.Cancel);
      rp.removeEventHandler(Reepay.Event.Close);
    };
  }, [
    sessionId,
    onPaymentSuccess,
    onPaymentError,
    onPaymentCancel,
    onModalClose,
  ]);

  return null;
};

export default PaymentPopup;
